import { render } from "./ItemRanking.vue?vue&type=template&id=8892fe60&scoped=true"
import script from "./ItemRanking.vue?vue&type=script&lang=js"
export * from "./ItemRanking.vue?vue&type=script&lang=js"

import "./ItemRanking.vue?vue&type=style&index=0&id=8892fe60&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8892fe60"]])

export default __exports__